import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts'
import { DIFFICULTY_CHART_COLORS, CHART_COLORS } from '../../../constants/colors'

interface YearData {
  year: number
  easyCount: number
  easyPercentage: number
  mediumCount: number
  mediumPercentage: number
  hardCount: number
  hardPercentage: number
  totalQuestions: number
}

interface DifficultyAreaChartProps {
  data: YearData[]
  showPercentage?: boolean
}

export default function DifficultyAreaChart({
  data,
  showPercentage = true,
}: DifficultyAreaChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-500">
        No difficulty trend data available
      </div>
    )
  }

  const chartData = data.map((item) => ({
    year: item.year,
    Easy: showPercentage ? item.easyPercentage : item.easyCount,
    Medium: showPercentage ? item.mediumPercentage : item.mediumCount,
    Hard: showPercentage ? item.hardPercentage : item.hardCount,
  }))

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART_COLORS.grid} />
        <XAxis dataKey="year" tick={{ fontSize: 12 }} />
        <YAxis
          tick={{ fontSize: 12 }}
          tickFormatter={(value) => (showPercentage ? `${value}%` : String(value))}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            padding: '8px 12px',
          }}
          formatter={(value) =>
            showPercentage ? `${Number(value).toFixed(1)}%` : value
          }
        />
        <Legend />
        <Area
          type="monotone"
          dataKey="Easy"
          stackId="1"
          stroke={DIFFICULTY_CHART_COLORS[0].color}
          fill={DIFFICULTY_CHART_COLORS[0].color}
          fillOpacity={0.6}
        />
        <Area
          type="monotone"
          dataKey="Medium"
          stackId="1"
          stroke={DIFFICULTY_CHART_COLORS[1].color}
          fill={DIFFICULTY_CHART_COLORS[1].color}
          fillOpacity={0.6}
        />
        <Area
          type="monotone"
          dataKey="Hard"
          stackId="1"
          stroke={DIFFICULTY_CHART_COLORS[2].color}
          fill={DIFFICULTY_CHART_COLORS[2].color}
          fillOpacity={0.6}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
